import { render, staticRenderFns } from "./DialogueItem.vue?vue&type=template&id=c76808de&scoped=true&"
import script from "./DialogueItem.vue?vue&type=script&lang=js&"
export * from "./DialogueItem.vue?vue&type=script&lang=js&"
import style0 from "./DialogueItem.vue?vue&type=style&index=0&id=c76808de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76808de",
  null
  
)

export default component.exports